import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading2 = _resolveComponent("Heading2")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Container = _resolveComponent("Container")!
  const _component_Section = _resolveComponent("Section")!

  return (_openBlock(), _createBlock(_component_Section, {
    id: "education",
    border: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Container, null, {
        default: _withCtx(() => [
          _createVNode(_component_Heading2, {
            icon: "fa-solid fa-graduation-cap",
            class: "pb-12"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("education.header")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Timeline, { entities: _ctx.entities }, null, 8, ["entities"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}